import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomChallengesBannerComponent } from './custom-challenges-banner/custom-challenges-banner.component';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { MediaModule } from '@spartacus/storefront';

@NgModule({
  declarations: [
    CustomChallengesBannerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    MediaModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SeqirusChallengesBannerComponent: {
          component: CustomChallengesBannerComponent
        },
      }
    })
  ]
})
export class FluadProductModule { }
